<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}:{{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" :busy="isBusy" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Voci Menu" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button v-if="!row.item.fisso" v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Voci Menu" @click="onDelete(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                            <!-- {{ row.item.id }} -->
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <configurazione-generale-pazienti-menu-modal-edit-component ref="ConfigurazioneGeneralePazientiMenuModalEditComponent" @afterSave="onAfterSaveModal"> </configurazione-generale-pazienti-menu-modal-edit-component>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ConfigurazioneGeneralePazientiMenuModalEditComponent from "./ConfigurazioneGeneralePazientiMenuModalEditComponent.vue";
export default {
    components: { ConfigurazioneGeneralePazientiMenuModalEditComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            filtroConfigurazionePazientiMenu: {},
            pathResource: "/rsapazientimenu",
            showModalLoading: false,
            show: true,
            perPage: 50,
            currentPage: 1,
            allItems: [],

            rows: 0,
            rowsUsers: 0,
            listKey: 0,
            isBusy: false,
            items: [],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                { label: "Voci Menu", key: "text", sortable: true },
                { label: "Path", key: "viewId", sortable: true },
                { label: "Application Reference", key: "applicationReference", thStyle: "width: 15rem" },
                { label: "Regime Reference", key: "regimeReference", thStyle: "width: 15rem" },
                // { label: "Stato", key: "stato", sortable: true },
                {
                    label: "Posizione",
                    key: "ordering",
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            this.updateItems();
        },
    },
    methods: {
        loadData(filtro) {
            let me = this;
            //filtro.page = me.currentPage;
            //filtro.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource + "/all", filtro, me.loadDataPazientiMenuSuccess, me.loadDataPazientiMenuError);
        },
        loadDataPazientiMenuSuccess(response) {
            let me = this;
            me.allItems = response.data.data.list;
            me.rows = response.data.data.list.length;
            me.updateItems();
            me.$emit("afterLoadData");
        },
        loadDataPazientiMenuError(error) {
            let me = this;
            console.log("Errore nel caricamento delle voci menu pazienti:", error);
            me.$emit("afterLoadData");
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onEdit(item) {
            let me = this;
            me.$refs.ConfigurazioneGeneralePazientiMenuModalEditComponent.show(item);
        },
        onDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare questa voce menu: " + item.text, {
                    title: "Conferma eliminazione",
                    size: "sm",
                    okVariant: "danger",
                    okTitle: "Elimina",
                    cancelTitle: "Annulla",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deletePazientiMenu(item.routeId);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deletePazientiMenu(routeId) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + routeId, me.deletePazientiMenuSuccess, me.deletePazientiMenuError);
        },
        deletePazientiMenuSuccess() {
            let me = this;
            me.$bvModal.msgBoxOk("Voce menu eliminata con successo.", {
                title: "Eliminazione completata",
                size: "sm",
                okVariant: "success",
                centered: true,
            });
            me.loadData();
        },
        deletePazientiMenuError() {
            let me = this;
            me.$bvModal.msgBoxOk("Errore durante l'eliminazione della voce menu.", {
                title: "Errore",
                size: "sm",
                okVariant: "danger",
                centered: true,
            });
        },
        updateItems() {
            let me = this;
            let start = (me.currentPage - 1) * me.perPage;
            let end = start + me.perPage;
            me.items = me.allItems.slice(start, end);
        },
        onAfterSaveModal() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
